import { render, staticRenderFns } from "./AccommodationAlert.vue?vue&type=template&id=ef6d82f2&lang=pug&"
import script from "./AccommodationAlert.vue?vue&type=script&lang=js&"
export * from "./AccommodationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports